/**
 * @file コンポーネント：ログインメニュー スタイル管理
 */

// ライブラリ読み込み
import styled from "styled-components";

// スタイル
export const StyledLoginmenu = styled.nav`
    padding-right: 0;
`;

export const StyledLoginmenuAnchor = styled.a`
    display: block;
    color: #00214c;
    text-align: center;

    &.is-notification {
        position: relative;

        &::after {
            display: inline-block;
            position: absolute;
            top: 0;
            right: 0;
            width: 1em;
            height: 1em;
            border-radius: 50%;
            background-color: #ad401f;
            color: #ffffff;
            font-size: 15px;
            line-height: 1em;
            text-align: center;
            content: "!";
        }
    }
`;

export const StyledLoginmenuAnchorIcon = styled.span`
    display: block;
    margin-bottom: 4px;
    font-size: 21px;
    line-height: 32px;
`;

export const StyledLoginmenuAnchorText = styled.span`
    display: block;
    font-size: 10px;
    line-height: 12px;
    white-space: nowrap;
`;

export const StyledLoginmenuList = styled.ul`
    display: flex;
    align-items: center;
    height: 100%;
`;

export const StyledLoginmenuListItem = styled.li`
    margin-right: 12px;

    &:last-of-type {
        margin-right: 0;
    }
`;
